"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTransferInMutation = void 0;
var transfer_1 = require("../transfer");
var react_query_1 = require("react-query");
function useTransferInMutation(options) {
    return (0, react_query_1.useMutation)(transfer_1.transfer, options);
}
exports.useTransferInMutation = useTransferInMutation;
